import {
  Availabilities as GeneratedAvailabilities,
  DayAvailability as GeneratedDayAvailability,
  PartnerInfo as GeneratedPartnerInfo,
  PartnerServiceInfo as GeneratedPartnerServiceInfo,
  ServiceInfo as GeneratedServiceInfo,
  BookAppointmentResponse as GeneratedBookAppointmentResponse,
  PatientAppointmentsResponse as GeneratedPatientAppointmentsResponse,
  PatientAppointmentItem as GeneratedPatientAppointmentItem,
  SlotStatusHistory as GeneratedSlotStatusHistory,
} from '@generated/models'

// Local aliases to generated API models to keep frontend types in sync with backend
export type Availabilities = GeneratedAvailabilities
export type DayAvailability = GeneratedDayAvailability
export type PartnerInfo = GeneratedPartnerInfo
export type PartnerServiceInfo = GeneratedPartnerServiceInfo
export type ServiceInfo = GeneratedServiceInfo
export type BookAppointmentResponse = GeneratedBookAppointmentResponse
export type PatientAppointmentsResponse = GeneratedPatientAppointmentsResponse
export type PatientAppointmentItem = GeneratedPatientAppointmentItem
export type SlotStatusHistory = GeneratedSlotStatusHistory
export {StatusUpdatedByRole} from '@generated/models'
export {SlotStatusType} from '@generated/models'
